var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.927 1.105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.494 17.667H.726A.724.724 0 0 1 0 16.944V2.65a.724.724 0 0 1 .726-.723h15.783a.724.724 0 0 1 .726.723V10a.726.726 0 0 1-1.452 0V3.374H1.452v12.847h8.042a.723.723 0 1 1 0 1.446z",
    transform: "translate(0 .217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.858.8H.076A.724.724 0 0 1-.65.073.724.724 0 0 1 .076-.65h15.782a.724.724 0 0 1 .726.723.724.724 0 0 1-.726.727z",
    transform: "translate(.65 7.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.076 4.369a.724.724 0 0 1-.726-.723V.073A.724.724 0 0 1 .076-.65.724.724 0 0 1 .8.073v3.573a.724.724 0 0 1-.724.723z",
    transform: "translate(4.954 .65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.076 4.369a.724.724 0 0 1-.726-.723V.073A.724.724 0 0 1 .076-.65.724.724 0 0 1 .8.073v3.573a.724.724 0 0 1-.724.723z",
    transform: "translate(12.128 .65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.663 14.363a.647.647 0 0 1-.346-.1l-1.36-.856a.65.65 0 0 1-.3-.55v-2a.65.65 0 1 1 1.3 0V12.5l1.056.665a.65.65 0 0 1-.347 1.2z",
    transform: "translate(1.609 1.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.858-.65A5.488 5.488 0 1 1-.65 4.838 5.5 5.5 0 0 1 4.858-.65zm0 9.529A4.041 4.041 0 1 0 .8 4.838a4.054 4.054 0 0 0 4.058 4.041z",
    transform: "translate(8.78 9.465)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.c3f8efaed73c335fbf4f00e57abcda6c.svg";
export { ForwardRef as ReactComponent };